/**
 * Footer — status line with backend liveness + version + repo link.
 */

import { useEffect, useState } from "react";
import { checkHealth } from "@/lib/api";

export function Footer() {
  const [healthy, setHealthy] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;
    const run = () => checkHealth().then((ok) => mounted && setHealthy(ok));
    run();
    const t = setInterval(run, 30_000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  const dotClass =
    healthy === null
      ? "bg-[--text-subtle]"
      : healthy
        ? "bg-[--success]"
        : "bg-[--danger]";
  const dotLabel =
    healthy === null ? "Checking backend…" : healthy ? "Backend live" : "Backend unreachable";

  return (
    <footer className="mx-auto mt-12 mb-6 max-w-5xl px-4 text-[11px] text-[--text-subtle] sm:px-6">
      <div className="flex flex-col items-center justify-between gap-2 border-t border-[--border] pt-4 sm:flex-row">
        <div className="flex items-center gap-2" role="status" aria-live="polite">
          <span aria-hidden="true" className={`inline-block size-2 rounded-full ${dotClass}`} />
          <span>{dotLabel}</span>
        </div>
        <div className="flex items-center gap-3">
          <a
            href="https://github.com/thangstad/asic-router"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[--text]"
          >
            backend
          </a>
          <span>·</span>
          <a
            href="https://github.com/thangstad/asic-router-web"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[--text]"
          >
            frontend
          </a>
          <span>·</span>
          <span className="num">v0.1.0</span>
        </div>
      </div>
    </footer>
  );
}
